module.exports = __webpack_public_path__ + "media/images/icons/down_arrow-f80f1f1652cc63f62937c61106c142e0.png";